window.theme = window.theme || {};
window.slate = window.slate || {};

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function defaultTo (value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ',');
      decimal = defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

theme.delegate = {
  on: function(event, callback, options){
    if( !this.namespaces ) // save the namespaces on the DOM element itself
      this.namespaces = {};

    this.namespaces[event] = callback;
    options = options || false;

    this.addEventListener(event.split('.')[0], callback, options);
    return this;
  },
  off: function(event) {
    if (!this.namespaces) { return }
    this.removeEventListener(event.split('.')[0], this.namespaces[event]);
    delete this.namespaces[event];
    return this;
  }
};

// Extend the DOM with these above custom methods
window.on = Element.prototype.on = theme.delegate.on;
window.off = Element.prototype.off = theme.delegate.off;

theme.utils = {
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  },

  wrap: function(el, wrapper) {
    el.parentNode.insertBefore(wrapper, el);
    wrapper.appendChild(el);
  },

  debounce: function(wait, callback, immediate) {
    var timeout;
    return function() {
      var context = this, args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) callback.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) callback.apply(context, args);
    }
  },

  throttle: function(limit, callback) {
    var waiting = false;
    return function () {
      if (!waiting) {
        callback.apply(this, arguments);
        waiting = true;
        setTimeout(function () {
          waiting = false;
        }, limit);
      }
    }
  },

  prepareTransition: function(el, callback) {
    el.addEventListener('transitionend', removeClass);

    function removeClass(evt) {
      el.classList.remove('is-transitioning');
      el.removeEventListener('transitionend', removeClass);
    }

    el.classList.add('is-transitioning');
    el.offsetWidth; // check offsetWidth to force the style rendering

    if (typeof callback === 'function') {
      callback();
    }
  },

  // _.compact from lodash
  // Creates an array with all falsey values removed. The values `false`, `null`,
  // `0`, `""`, `undefined`, and `NaN` are falsey.
  // _.compact([0, 1, false, 2, '', 3]);
  // => [1, 2, 3]
  compact: function(array) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  serialize: function(form) {
    var arr = [];
    Array.prototype.slice.call(form.elements).forEach(function(field) {
      if (
        !field.name ||
        field.disabled ||
        ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
      )
        return;
      if (field.type === 'select-multiple') {
        Array.prototype.slice.call(field.options).forEach(function(option) {
          if (!option.selected) return;
          arr.push(
            encodeURIComponent(field.name) +
              '=' +
              encodeURIComponent(option.value)
          );
        });
        return;
      }
      if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
        return;
      arr.push(
        encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
      );
    });
    return arr.join('&');
  }
};

theme.a11y = {
  trapFocus: function(options) {
    var eventsName = {
      focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
      focusout: options.namespace
        ? 'focusout.' + options.namespace
        : 'focusout',
      keydown: options.namespace
        ? 'keydown.' + options.namespace
        : 'keydown.handleFocus'
    };

    // Get every possible visible focusable element
    var focusableEls = options.container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])');
    var elArray = [].slice.call(focusableEls);
    var focusableElements = elArray.filter(el => el.offsetParent !== null);

    var firstFocusable = focusableElements[0];
    var lastFocusable = focusableElements[focusableElements.length - 1];

    if (!options.elementToFocus) {
      options.elementToFocus = options.container;
    }

    options.container.setAttribute('tabindex', '-1');
    options.elementToFocus.focus();

    document.documentElement.off('focusin');
    document.documentElement.on(eventsName.focusout, function() {
      document.documentElement.off(eventsName.keydown);
    });

    document.documentElement.on(eventsName.focusin, function(evt) {
      if (evt.target !== lastFocusable && evt.target !== firstFocusable) return;

      document.documentElement.on(eventsName.keydown, function(evt) {
        _manageFocus(evt);
      });
    });

    function _manageFocus(evt) {
      if (evt.keyCode !== 9) return;
      /**
       * On the first focusable element and tab backward,
       * focus the last element
       */
      if (evt.target === firstFocusable && evt.shiftKey) {
        evt.preventDefault();
        lastFocusable.focus();
      }
    }
  },
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.container) {
      options.container.removeAttribute('tabindex');
    }

    document.documentElement.off(eventName);
  },

  lockMobileScrolling: function(namespace, element) {
    var el = element ? element : document.documentElement;
    document.documentElement.classList.add('lock-scroll');
    el.on('touchmove' + namespace, function() {
      return true;
    });
  },

  unlockMobileScrolling: function(namespace, element) {
    document.documentElement.classList.remove('lock-scroll');
    var el = element ? element : document.documentElement;
    el.off('touchmove' + namespace);
  }
};

theme.Drawers = (function() {
  function Drawers(id, name) {
    this.config = {
      id: id,
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + name,
      openClass: 'js-drawer-open',
      closingClass: 'js-drawer-closing',
      activeDrawer: 'drawer--is-open',
      namespace: '.drawer-' + name
    };

    this.nodes = {
      page: document.querySelector('#MainContent')
    };

    this.drawer = document.querySelector('#' + id);
    this.isOpen = false;

    if (!this.drawer) {
      return;
    }

    this.init();
  }

  Drawers.prototype = Object.assign({}, Drawers.prototype, {
    init: function() {
      // Setup open button(s)
      document.querySelectorAll(this.config.open).forEach(openBtn => {
        openBtn.setAttribute('aria-expanded', 'false');
        openBtn.addEventListener('click', this.open.bind(this));
      });

      this.drawer.querySelector(this.config.close).addEventListener('click', this.close.bind(this));

      // Close modal if a drawer is opened
      document.addEventListener('modalOpen', function() {
        this.close();
      }.bind(this));
    },

    open: function(evt, returnFocusEl) {
      if (evt) {
        evt.preventDefault();
      }

      if (this.isOpen) {
        return;
      }

      // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        // save the source of the click, we'll focus to this on close
        evt.currentTarget.setAttribute('aria-expanded', 'true');
        this.activeSource = evt.currentTarget;
      } else if (returnFocusEl) {
        returnFocusEl.setAttribute('aria-expanded', 'true');
        this.activeSource = returnFocusEl;
      }

      theme.utils.prepareTransition(this.drawer, function() {
        this.drawer.classList.add(this.config.activeDrawer);
      }.bind(this));

      document.documentElement.classList.add(this.config.openClass);
      this.isOpen = true;

      theme.a11y.trapFocus({
        container: this.drawer,
        namespace: 'drawer_focus'
      });

      document.dispatchEvent(new CustomEvent('drawerOpen'));
      document.dispatchEvent(new CustomEvent('drawerOpen.' + this.config.id));

      this.bindEvents();
    },

    close: function(evt) {
      if (!this.isOpen) {
        return;
      }

      // Do not close if click event came from inside drawer
      if (evt) {
        if (evt.target.closest('.js-drawer-close')) {
          // Do not close if using the drawer close button
        } else if (evt.target.closest('.drawer')) {
          return;
        }
      }

      evt.preventDefault();

      // deselect any focused form elements
      document.activeElement.blur();

      theme.utils.prepareTransition(this.drawer, function() {
        this.drawer.classList.remove(this.config.activeDrawer);
      }.bind(this));

      document.documentElement.classList.remove(this.config.openClass);
      document.documentElement.classList.add(this.config.closingClass);

      window.setTimeout(function() {
        document.documentElement.classList.remove(this.config.closingClass);
        if (this.activeSource && this.activeSource.getAttribute('aria-expanded')) {
          this.activeSource.setAttribute('aria-expanded', 'false');
          this.activeSource.focus();
        }
      }.bind(this), 500);

      this.isOpen = false;

      theme.a11y.removeTrapFocus({
        container: this.drawer,
        namespace: 'drawer_focus'
      });

      this.unbindEvents();
    },

    bindEvents: function() {
      // Clicking out of drawer closes it
      window.on('click' + this.config.namespace, function(evt) {
        this.close(evt)
        return;
      }.bind(this));

      // Pressing escape closes drawer
      window.on('keyup' + this.config.namespace, function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }.bind(this));

      theme.a11y.lockMobileScrolling(this.config.namespace, this.nodes.page);
    },

    unbindEvents: function() {
      window.off('click' + this.config.namespace);
      window.off('keyup' + this.config.namespace);

      theme.a11y.unlockMobileScrolling(this.config.namespace, this.nodes.page);
    }
  });

  return Drawers;
})();

theme.CartDrawer = (function() {
  var selectors = {
    drawer: '#CartDrawer',
    form: '#CartDrawerForm',
  };

  function CartDrawer() {
    this.drawerElement = document.querySelector(selectors.drawer);
    
    if (this.drawerElement) {
      this.form = document.querySelector(selectors.form);
      this.drawer = new theme.Drawers('CartDrawer', 'cart');
      
      this.init();
    }
  }

  CartDrawer.prototype = Object.assign({}, CartDrawer.prototype, {
    init: function() {
      this.cartForm = new theme.CartForm(this.form);
      this.cartForm.buildCart();

      document.addEventListener('ajaxProduct:added', function(evt) {
        this.cartForm.buildCart();
        theme.cart.getCart().then((response) => {
          theme.cart.cartCallback(response);

          const drawerScroller = document.querySelector('.drawer__scrollable');
          if (drawerScroller) {
            drawerScroller.scrollTo({top: 0, behavior: 'smooth'});
          }
        });

        this.open();
      }.bind(this));

      // Dev-friendly way to open cart
      document.addEventListener('cart:open', this.open.bind(this));
      document.addEventListener('cart:close', this.close.bind(this));
    },

    open: function() {
      this.drawer.open();
    },

    close: function() {
      this.drawer.close();
    },
  });

  return CartDrawer;
})();

theme.cart = {
  getCart: function() {
    var url = ''.concat(theme.routes.cart, '?t=').concat(Date.now());
    return fetch(url, {
      credentials: 'same-origin',
      method: 'GET'
    }).then(response => response.json());
  },

  getCartProductMarkup: function() {
    var url = ''.concat(theme.routes.cartPage, '?t=').concat(Date.now());

    url = url.indexOf('?') === -1 ? (url + '?view=ajax') : (url + '&view=ajax');

    return fetch(url, {
      credentials: 'same-origin',
      method: 'GET'
    })
    .then(function(response) {
      return response.text()
    });
  },

  addItem: function(variantId, qty) {
    return this._updateCart({
      url: ''.concat(theme.routes.cartAdd, '?t=').concat(Date.now()),
      data: JSON.stringify({
        id: variantId,
        quantity: qty
      })
    })
  },

  changeItem: function(key, qty) {
    return this._updateCart({
      url: ''.concat(theme.routes.cartChange, '?t=').concat(Date.now()),
      data: JSON.stringify({
        id: key,
        quantity: qty
      })
    })
  },

  _updateCart: function(params) {
    return fetch(params.url, {
      method: 'POST',
      body: params.data,
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.json())
    .then(function(cart) {
      if (typeof _swat !== 'undefined') {
        _swat.initializeActionButtons(".cart__items");
      }
      return cart;
    });
  },

  updateAttribute: function(key, value) {
    return this._updateCart({
      url: '/cart/update.js',
      data: JSON.stringify({
        attributes: {
          [key]: theme.cart.attributeToString(value)
        }
      })
    });
  },

  updateNote: function(note) {
    return this._updateCart({
      url: '/cart/update.js',
      data: JSON.stringify({
        note: theme.cart.attributeToString(note)
      })
    });
  },

  attributeToString: function(attribute) {
    if ((typeof attribute) !== 'string') {
      attribute += '';
      if (attribute === 'undefined') {
        attribute = '';
      }
    }
    return attribute.trim();
  },

  cartCallback: function(cart) {
    theme.cart.cartData = cart;
    const drawerForm = document.querySelector('#CartDrawer');
    if (cart.items.length <= 3) {
      drawerForm && drawerForm.classList.add('hide-toggle-items-btn');
    } else {
      drawerForm && drawerForm.classList.remove('hide-toggle-items-btn');
    }
    
    theme.cart.calculateProgress(cart);
    if (typeof _swat !== 'undefined') {
      _swat.initializeActionButtons(".cart__items");
    }
  },

  calculateProgress(cart) {

    const cartTotal = cart.total_price;
    const threshold = window.setThreshold * 100;
  
    var newProgressNum = (threshold - cartTotal) / 100 * 100;

    // calculate how far progress is from the total as a percentage
    const result = 100 * cartTotal / threshold;
    const progressPercentage = `${result}%`;

    // Update progress bar
    $('.progress-meter').css('width', progressPercentage); 

    // Update the progess text. If threshold is met, show success message
    var newProgressNum = (threshold - cartTotal) / 100 * 100;
    const progressDollarNum = slate.Currency.formatMoney(newProgressNum, theme.moneyFormat).replace('.00', '');

    if (result < 100) {
      $('.js-money-remainder').text(` ${progressDollarNum} `);
      
      // var shippingMessage = "<span>You're " + progressDollarNum + " away from free shipping!</span>";
      // $(".shipping-message").html(shippingMessage);
      $('.shipping-success-message').addClass('hide');
      $('.shipping-message').removeClass('hide');
      $('.progress-meter').css({
        WebkitTransition: 'width 0.3s ease-in',
        MozTransition: 'width 0.3s ease-in',
        MsTransition: 'width 0.3s ease-in',
        OTransition: 'width 0.3s ease-in',
        transition: 'width 0.3s ease-in',
      });
    } else {
      $('.shipping-success-message').removeClass('hide');
      $('.shipping-message').addClass('hide');
    }
  }
}

/*============================================================================
  CartForm
  - Prevent checkout when terms checkbox exists
  - Listen to quantity changes, rebuild cart (both widget and page)
==============================================================================*/
theme.CartForm = (function() {
  var selectors = {
    products: '[data-products]',
    cartMain: '[data-cart-main]',
    qtySelector: '.js-qty__wrapper',
    discounts: '[data-discounts]',
    savings: '[data-savings]',
    subTotal: '[data-subtotal]',

    cartBubble: '.cart-link__bubble',
    cartNote: '[name="note"]',
    termsCheckbox: '.cart__terms-checkbox',
    checkoutBtn: '.cart__checkout'
  };

  var classes = {
    btnLoading: 'btn--loading'
  };

  var config = {
    requiresTerms: false
  };

  function CartForm(form) {
    if (!form) {
      return;
    }

    this.form = form;
    this.wrapper = form.parentNode;
    this.location = form.dataset.location;
    this.namespace = '.cart-' + this.location;
    this.cartMain = form.querySelector(selectors.cartMain);
    this.products = form.querySelector(selectors.products);
    this.submitBtn = form.querySelector(selectors.checkoutBtn);

    this.discounts = form.querySelector(selectors.discounts);
    this.savings = form.querySelector(selectors.savings);
    this.subtotal = form.querySelector(selectors.subTotal);
    this.termsCheckbox = form.querySelector(selectors.termsCheckbox);
    this.noteInput = form.querySelector(selectors.cartNote);

    if (this.termsCheckbox) {
      config.requiresTerms = true;
    }

    this.init();
  }

  CartForm.prototype = Object.assign({}, CartForm.prototype, {
    init: function() {
      this.initQtySelectors();

      document.addEventListener('cart:quantity' + this.namespace, this.quantityChanged.bind(this));

      const removeButtons = Array.prototype.slice.call(document.querySelectorAll('.js-remove-item'));
      removeButtons.forEach(button => {
        button.addEventListener('click', (evt) => {
          evt.preventDefault();
          this.removeItem(evt);
        });
      })

      this.form.on('submit' + this.namespace, this.onSubmit.bind(this));

      if (this.noteInput) {
        this.noteInput.addEventListener('change', function() {
          var newNote = this.value;
          theme.cart.updateNote(newNote);
        });
      }

      // Dev-friendly way to build the cart
      document.addEventListener('cart:build', function() {
        this.buildCart();
      }.bind(this));
    },

    reInit: function() {      
      this.initQtySelectors();

      const removeButtons = Array.prototype.slice.call(document.querySelectorAll('.js-remove-item'));
      removeButtons.forEach(button => {
        button.addEventListener('click', (evt) => {
          evt.preventDefault();
          this.removeItem(evt);
        });
      })
    },

    onSubmit: function(evt) {
      this.submitBtn.classList.add(classes.btnLoading);

      if (config.requiresTerms) {
        if (this.termsCheckbox.checked) {
          // continue to checkout
        } else {
          alert(theme.strings.cartTermsConfirmation);
          this.submitBtn.classList.remove(classes.btnLoading)
          evt.preventDefault();
          return false;
        }
      }
    },

    /*============================================================================
      Query cart page to get markup
    ==============================================================================*/
    _parseProductHTML: function(html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      return {
        cartMain: doc.querySelector('[data-cart-main]'),
        items: doc.querySelector('.cart__items'),
        discounts: doc.querySelector('.cart__discounts')
      }
    },

    buildCart: function() {
      theme.cart.getCartProductMarkup().then(this.cartMarkup.bind(this));
    },

    cartMarkup: function(html) {
      var markup = this._parseProductHTML(html);
      var cartMain = markup.cartMain;
      var count = parseInt(cartMain.dataset.count);
      var subtotal = cartMain.dataset.cartSubtotal;
      var savings = cartMain.dataset.cartSavings;

      this.updateCartDiscounts(markup.discounts);
      this.updateSavings(savings);

      if (count > 0) {
        this.wrapper.classList.remove('is-empty');
      } else {
        this.wrapper.classList.add('is-empty');
      }

      this.updateCount(count);

      // Append item markup
      this.cartMain.innerHTML = '';
      this.cartMain.innerHTML = (cartMain.innerHTML);

      // Update subtotal
      this.subtotal.innerHTML = slate.Currency.formatMoney(subtotal, theme.settings.moneyFormat);

      this.reInit();

      if (window.AOS) { AOS.refreshHard() }

      if (Shopify && Shopify.StorefrontExpressButtons) {
        Shopify.StorefrontExpressButtons.initialize();
      }

      if (typeof _swat !== 'undefined') {
        _swat.initializeActionButtons(".cart__items");
      }
    },

    updateCartDiscounts: function(markup) {
      if (!this.discounts) {
        return;
      }
      this.discounts.innerHTML = '';
      this.discounts.append(markup);
    },

    /*============================================================================
      Quantity handling
    ==============================================================================*/
    initQtySelectors: function() {
      this.form.querySelectorAll(selectors.qtySelector).forEach(el => {
        var selector = new theme.QtySelector(el, {
          namespace: this.namespace,
          isCart: true
        });
      });
    },

    quantityChanged: function(evt) {
      var key = evt.detail[0];
      var qty = evt.detail[1];
      var el = evt.detail[2];

      if (!key || !qty) {
        return;
      }

      // Disable qty selector so multiple clicks can't happen while loading
      if (el) {
        el.classList.add('is-loading');
      }

      theme.cart.changeItem(key, qty)
        .then(function(cart) {
          if (cart.item_count > 0) {
            this.wrapper.classList.remove('is-empty');
          } else {
            this.wrapper.classList.add('is-empty');
          }

          this.buildCart();
          theme.cart.cartCallback(cart);

          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: {
              cart: cart
            }
          }));
        }.bind(this))
        .catch(function(XMLHttpRequest){});
    },

    removeItem: function(evt) {
      var key = evt.currentTarget.dataset.id;
      var qty = 0;

      if (!key) {
        return;
      }

      theme.cart.changeItem(key, qty)
        .then(function(cart) {
          if (cart.item_count > 0) {
            this.wrapper.classList.remove('is-empty');
          } else {
            this.wrapper.classList.add('is-empty');
          }

          this.buildCart();
          theme.cart.cartCallback(cart);

          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: {
              cart: cart
            }
          }));
        }.bind(this))
        .catch(function(XMLHttpRequest){});
    },

    updateCount(count) {
      const cartCountElements = [...document.querySelectorAll('.js-cart-count')];
      cartCountElements.forEach(element => {
        element.textContent = count;
        element.setAttribute('data-count', count)
      })
    },

    /*============================================================================
      Update elements of the cart
    ==============================================================================*/
    updateSubtotal: function(subtotal) {
      this.form.querySelector(selectors.subTotal).innerHTML = slate.Currency.formatMoney(subtotal, theme.settings.moneyFormat);
    },

    updateSavings: function(savings) {
      if (!this.savings) {
        return;
      }

      if (savings > 0) {
        var amount = slate.Currency.formatMoney(savings, theme.settings.moneyFormat);
        this.savings.classList.remove('hide');
        this.savings.innerHTML = theme.strings.cartSavings.replace('[savings]', amount);
      } else {
        this.savings.classList.add('hide');
      }
    }
  });

  return CartForm;
})();

theme.QtySelector = (function() {
  var selectors = {
    input: '.js-qty__num',
    plus: '.js-qty__adjust--plus',
    minus: '.js-qty__adjust--minus'
  };

  function QtySelector(el, options) {
    this.wrapper = el;
    this.plus = el.querySelector(selectors.plus);
    this.minus = el.querySelector(selectors.minus);
    this.input = el.querySelector(selectors.input);
    this.minValue = this.input.getAttribute('min') || 1;

    var defaults = {
      namespace: null,
      isCart: false,
      key: this.input.dataset.id
    };

    this.options = Object.assign({}, defaults, options);

    this.init();
  }

  QtySelector.prototype = Object.assign({}, QtySelector.prototype, {
    init: function() {
      this.plus.addEventListener('click', function(evt) {
        evt.preventDefault();
        var qty = this._getQty();
        this._change(qty + 1);
      }.bind(this));

      this.minus.addEventListener('click', function(evt) {
        evt.preventDefault();
        var qty = this._getQty();
        this._change(qty - 1);
      }.bind(this));

      this.input.addEventListener('change', function(evt) {
        evt.preventDefault();
        this._change(this._getQty());
      }.bind(this));
    },

    _getQty: function() {
      var qty = this.input.value;
      if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
        // We have a valid number!
      } else {
        // Not a number. Default to 1.
        qty = 1;
      }
      return parseInt(qty);
    },

    _change: function(qty) {
      if (qty <= this.minValue) {
        qty = this.minValue;
      }

      this.input.value = qty;

      if (this.options.isCart) {
        document.dispatchEvent(new CustomEvent('cart:quantity' + this.options.namespace, {
            detail: [this.options.key, qty, this.wrapper]
        }));
      }
    }
  });

  return QtySelector;
})();

theme.AjaxProduct = (function() {
  var status = {
    loading: false
  };

  function ProductForm(form, submit, args) {
    this.form = form;
    this.args = args;

    var submitSelector = submit ? submit : '.btn--add-to-cart';

    if (this.form) {
      this.addToCart = form.querySelector(submitSelector);
      this.form.addEventListener('submit', this.addItemFromForm.bind(this));
    }
  };

  ProductForm.prototype = Object.assign({}, ProductForm.prototype, {
    addItemFromForm: function(evt, callback) {
      // console.log(evt)
      evt.preventDefault();

      if (status.loading) {
        return;
      }

      // Loading indicator on add to cart button
      this.addToCart.classList.add('btn--loading');

      status.loading = true;

      let id = this.form.querySelector('[name=id]').value;
      let quantity = this.form.querySelector('[name=quantity]').value;
      let properties = ''

      if (typeof productsWithPurchaseLimit !== 'undefined' && productsWithPurchaseLimit.length > 0) {
        // Check Product purchase Limit setting
        const currentProductId = $(this).data('productId');
        let isProductWithLimit = false;
        let purchaseLimit = 1000;
        let quantityInCart = 0;
  
        productsWithPurchaseLimit.forEach((set) => {
          if (currentProductId == set.product.id) {
            isProductWithLimit = true;
            purchaseLimit = set.purchase_limit;
            // console.log(purchaseLimit);
          }
        });
  
        theme.cart.cartData.items.forEach((item) => {
          if (item.product_id == currentProductId) {
            quantityInCart = item.quantity;
          }
        });
  
        const $errorMessage = $('.template-product [data-section-type="product"] #error-message');
        const $cartErrorMessage = $('.template-product [data-section-type="product"] .cart-error-message');
        let errorMessage = '';
        if (isProductWithLimit) {
          if (quantityInCart >= purchaseLimit) {
            errorMessage = 'You have reached the purchase limit with this product.';
            $cartErrorMessage.html('');
            $errorMessage.html(errorMessage);
          } else {
            if (quantityInCart + parseFloat(quantity) > purchaseLimit) {
              errorMessage = `You can only purchase this product maximum ${purchaseLimit}`;
              $cartErrorMessage.html('');
              $errorMessage.html(errorMessage);
              quantity = purchaseLimit - quantityInCart;
            }
          }
        }
      }

      let formData = {
        items: [{
          id: id,
          quantity: quantity
        }]
      };

      if (evt.submitter.dataset.pdpGiftBtn == 'true') {
        const email = this.form.querySelector('[data-gift-email]'),
          name = this.form.querySelector('[data-gift-name]'),
          message = this.form.querySelector('[data-gift-message]'),
          sendOn = this.form.querySelector('[data-gift-send-on]');
          
        const validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        if (email.value == '' || !email.value.match(validRegex)) {
          const errorMessage = 'Please enter recipient email'
          this.handleError(errorMessage);
          setTimeout(() => {
            this.clearError()
            status.loading = false;
          }, 3000)
        } else {
          formData.items[0].properties = {
            'Recipient email': email.value,
            'Recipient name': name.value,
            'Message': message.value,
            'Send on': sendOn.value,
            "__shopify_send_gift_card_to_recipient": 'on',
          }

          // console.log(formData)

          this.addItem(formData)
        }

      } else {
        const enhanceOptions = [].slice.call(document.querySelectorAll("input[name='pp_en']:checked"));
        enhanceOptions.forEach((option) => {
          const pp_id = option.nextElementSibling.value;
          formData.items.push({
            id: pp_id,
            quantity: quantity
          })
        });

        this.addItem(formData);
      }
    },

    addItem: function(formData) {
      fetch(theme.routes.cartAdd, {
        method: 'POST',
        body: JSON.stringify(formData),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        }
        // headers: {
        //   'Content-Type': 'application/x-www-form-urlencoded',
        //   'X-Requested-With': 'XMLHttpRequest'
        // }
      })
      .then(response => response.json())
      .then(function(data) {
        if (data.status === 422) {
          this.error(data);
        } else {
          var product = data;
          this.success(product);
        }

        status.loading = false;
        this.addToCart.classList.remove('btn--loading');

        // Reload page if adding product from a section on the cart page
        if (document.body.classList.contains('template-cart')) {
          window.scrollTo(0, 0);
          location.reload();
        }
      }.bind(this));
    },

    success: function(product) {
      var errors = this.form.querySelector('.errors');
      if (errors) {
        errors.remove();
      }

      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: {
          product: product,
          addToCartBtn: this.addToCart
        }
      }));

      if (this.args && this.args.scopedEventId) {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added:' + this.args.scopedEventId, {
          detail: {
            product: product,
            addToCartBtn: this.addToCart
          }
        }));
      }

      if (typeof _swat !== 'undefined') {
        _swat.initializeActionButtons(".cart__items");
      }
    },

    error: function(error) {
      if (!error.description) {
        console.warn(error);
        return;
      }
      
      this.handleError(error.description);

      document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
        detail: {
          errorMessage: error.description
        }
      }));

      if (this.args && this.args.scopedEventId) {
        document.dispatchEvent(new CustomEvent('ajaxProduct:error:' + this.args.scopedEventId, {
          detail: {
            errorMessage: error.description
          }
        }));
      }
    },

    handleError: function(errorMessage) {
      var errors = this.form.querySelector('.pdp-form-error');
      if (errors) {
        errors.remove();
      }

      var errorDiv = document.createElement('div');
      errorDiv.classList.add('errors', 'text-center', 'pdp-form-error');
      errorDiv.textContent = errorMessage;
      this.form.append(errorDiv);
    },

    clearError() {
      var errors = this.form.querySelector('.pdp-form-error');
      if (errors) {
        errors.remove();
      }
    }
  });

  return ProductForm;
})();

document.addEventListener('DOMContentLoaded', () => {
  if (theme.settings.cartType === 'drawer') {
    if (!document.body.classList.contains('template-cart')) {
      new theme.CartDrawer();
    }

    const productForm = document.querySelector('.product__form');
    if (productForm) {
      new theme.AjaxProduct(productForm);
    }

    theme.cart.getCart().then(response => {
      theme.cart.cartCallback(response);
    });
  }

  if (document.body.classList.contains('template-cart')) {
    const cartNote = [...document.querySelectorAll('[name="note"]')];
    cartNote.forEach((element) => {
      element.addEventListener('change', function() {
        var newNote = this.value;
        theme.cart.updateNote(newNote);
      })
    })
  }
});
